import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../utils/apiClient";

type CreateUserWithAccessRequest = {
  email: string;
  groupId: number | null;
  airlineIds: number[];
};

const createUserWithAccess = async ({ email, groupId, airlineIds }: CreateUserWithAccessRequest): Promise<void> => {
  await api.post("/api/v1/users/access", {
    json: { email, groupId, airlineIds },
  });
};

export const useCreateUserWithAccessMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createUserWithAccess,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/v1/users"] });
    },
  });
};
